import React, { Fragment, useState } from "react";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import ToolButtonsContainer from "@common/components/ToolButtonsContainer";
import IconButton from "@common/components/IconButton";

import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ConfirmDialog, {
  ConfirmDialogProps,
} from "@common/components/Button/DeleteButton/dialog";
type WithConfirm = {
  withConfirm: true;
  ConfirmDialogProps: Omit<ConfirmDialogProps, "onConfirm">;
};
type WithoutConfirm = {
  withConfirm?: undefined | false;
  ConfirmDialogProps?: undefined;
};
type GenerateBillingButtonProps = {
  onClick: () => void;
} & (WithConfirm | WithoutConfirm);

const GenerateBillingButton = (props: GenerateBillingButtonProps) => {
  const { onClick, withConfirm = false } = props;

  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <Fragment>
      <ToolButtonsContainer>
        <Tooltip title={t("Generate Billing Entries") as string} arrow>
          <span>
            <IconButton size="small" onClick={() => setOpen(true)}>
              <AttachMoneyIcon />
            </IconButton>
          </span>
        </Tooltip>
      </ToolButtonsContainer>

      <ConfirmDialog
        {...props.ConfirmDialogProps}
        onConfirm={() => {
          setOpen(false);
          onClick();
        }}
        onClose={() => setOpen(false)}
        open={open}
        actionLabel={t("Generate")}
        confirmPrompt={t(
          "This will override any modifications you made to the list. Do you want to proceed?"
        )}
      />
    </Fragment>
  );
};

export default GenerateBillingButton;
